import React, { useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import { Spin, message, Progress, Typography } from 'antd';

import styled from "styled-components";
import { withStore, useStore } from 'react-context-hook'
import GameBoard from "./components/gameBoard/gameBoard";
import HiddenView from "./components/hiddenView/hiddenView";
import SetupScreen from "./components/setupScreen/setupScreen";
import useInterval from './hooks/useInterval';

import { useTracking } from './hooks/useTracking';
import "antd/dist/antd.css";
import SocketContext from './socket-context'
import * as io from 'socket.io-client'

const { Title } = Typography;

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const LoadingWrapper = styled.div`
  margin-top: 32px;
  width: 30%;
`;

const initialState = {
    player: -1,
    agents: [0, 2, 2, 2],
    setup: true,
    points: [0, 0, 0, 0],
    choose_phoenix: [],
    predictedHandCards: {
        cards: [[],[],[],[]],
        arg: 0,
        prob: 0,
        loading: false,
    },
    game: {
        started: false,
        cardStack: [],
        cardCounts: [0,0,0,0],
        handCards: [[],[],[],[]],
        currentPlayer: -1,
        tichus: [false, false, false, false],
        grandTichus: [false, false, false, false],
        trickWinner: -1,
        done: true,
        possibleActions: [],
        points: [0, 0, 0, 0],
        possibleCombos: [0, 0, 0, 0],
        wish: undefined,
    }
};
let apiHost = 'http://127.0.0.1:8000';
if (process.env.NODE_ENV === 'production') {
    apiHost = 'https://tichu-backend.herokuapp.com';
}
const socket = io(apiHost + '/socket');

const App = () => {
    useTracking('G-267HRQ1CLT');
    const [initialLoad, setInitialLoading] = useState(true);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [gameState, setGameState] = useStore('game', {});
    const [player] = useStore('player', -1);
    const [setupGame, setSetupGame] = useStore('setup', true);
    const [choosePhoenix, setChoosePhoenix] = useStore('choose_phoenix', []);
    const [, setPoints] = useStore('points', [0, 0, 0, 0]);
    const [, setPredictedHandCards] = useStore('predictedHandCards', {});

    useInterval(() => {
        // Your custom logic here
        setLoadingProgress(loadingProgress + 1);
    }, initialLoad ? 200 : null);


    useEffect(() => {
        if (initialLoad) {
            fetch(apiHost + '/state')
                .then(res => res.json())
                .then((data) => {
                    setInitialLoading(false);
                    if (!data.started){
                        setSetupGame(true);
                    }
                    else {
                        setSetupGame(false);
                        setGameState({...gameState, ...data});
                    }
                    setPoints(data.points)
                })
                .catch(console.log);
        }
        socket.on("connect", data => {
            console.log('connect', data)
        });
        socket.on("disconnect", data => {
            console.log('Disconnect', data)
        });
        socket.on("state_event", data => {
            console.log('Event', data)
            if (!data.started){
                setSetupGame(true);
            }
            else {
                setSetupGame(false);
                setGameState({...gameState, ...data});
                setPoints(data.points);
            }
        });
        socket.on("handcards_pred_event", data => {
            console.log('Event Handcard', data)
            setPredictedHandCards({...data, loading: false});
        });
        socket.on("error", data => {
            console.log('Error', data.message);
            message.error(data.message)
        });
        socket.on("choose_phoenix", data => {
            console.log('choose_phoenix', data.ranks);
            setChoosePhoenix(data.ranks);
        });
    }, []);
    let childComponent;
    let hiddenComponent = <HiddenView />;
    if (initialLoad) {
        childComponent = (
            <SpinnerWrapper>
                {loadingProgress > 10 ? (
                    <>
                        <Title level={4}>Tichu Environment Loading...</Title>
                        <LoadingWrapper>
                            <Progress percent={loadingProgress} status="active" />
                        </LoadingWrapper>
                    </>
                ) : (<Spin />)}
            </SpinnerWrapper>
        )
        hiddenComponent = (
            <SpinnerWrapper>
                <Spin />
            </SpinnerWrapper>
        )
    }
    else if (setupGame || player < 0) {
        childComponent = <SetupScreen join={!setupGame && player < 0} socket={socket}/>
    }
    else childComponent = <GameBoard />
    return (
            <SocketContext.Provider value={socket}>
                <Switch>
                    <Route path="/hidden">
                        {hiddenComponent}
                    </Route>
                    <Route path="/">
                        {childComponent}
                    </Route>
                </Switch>
            </SocketContext.Provider>
    );
};

const RouterApp = () => (
    <Router>
        <App />
    </Router>
)

export default withStore(RouterApp, initialState);
//
// import { Client } from 'boardgame.io/react';
// import { SocketIO } from 'boardgame.io/multiplayer'
//
// import React from 'react';
//
// class TicTacToeBoard extends React.Component {
//     onClick(id) {
//         if (this.isActive(id)) {
//             this.props.moves.clickCell(id);
//             this.props.events.endTurn();
//         }
//     }
//
//     isActive(id) {
//         if (!this.props.isActive) return false;
//         if (this.props.G.cells[id] !== null) return false;
//         return true;
//     }
//
//     render() {
//         let winner = '';
//         if (this.props.ctx.gameover) {
//             winner =
//                 this.props.ctx.gameover.winner !== undefined ? (
//                     <div id="winner">Winner: {this.props.ctx.gameover.winner}</div>
//                 ) : (
//                     <div id="winner">Draw!</div>
//                 );
//         }
//
//         const cellStyle = {
//             border: '1px solid #555',
//             width: '50px',
//             height: '50px',
//             lineHeight: '50px',
//             textAlign: 'center',
//         };
//
//         let tbody = [];
//         for (let i = 0; i < 3; i++) {
//             let cells = [];
//             for (let j = 0; j < 3; j++) {
//                 const id = 3 * i + j;
//                 cells.push(
//                     <td style={cellStyle} key={id} onClick={() => this.onClick(id)}>
//                         {this.props.G.cells[id]}
//                     </td>
//                 );
//             }
//             tbody.push(<tr key={i}>{cells}</tr>);
//         }
//
//         return (
//             <div>
//                 <table id="board">
//                     <tbody>{tbody}</tbody>
//                 </table>
//                 {winner}
//             </div>
//         );
//     }
// }
//
// // Return true if `cells` is in a winning configuration.
// function IsVictory(cells) {
//
// }
//
// // Return true if all `cells` are occupied.
// function IsDraw(cells) {
//     return cells.filter(c => c === null).length == 0;
// }
//
// const TicTacToe = {
//     setup: () => ({ cells: Array(9).fill(null) }),
//
//     moves: {
//         clickCell: (G, ctx, id) => {
//             if (G.cells[id] === null) {
//                 G.cells[id] = ctx.currentPlayer;
//             }
//         },
//     },
//
//     endIf: (G, ctx) => {
//         if (IsVictory(G.cells)) {
//             return { winner: ctx.currentPlayer };
//         }
//         if (IsDraw(G.cells)) {
//             return { draw: true };
//         }
//     },
// };
//
// const TicTacToeClient = Client({ game: TicTacToe, board: TicTacToeBoard, multiplayer: SocketIO({ server: 'localhost:8000' }) });
//
// const App = () => (
//     <div>
//         <TicTacToeClient playerID="0" />
//         <TicTacToeClient playerID="1" />
//     </div>
// );
//
// export default App;
